import BlogValuePropositionCard from './BlogValuePropositionCard';

export default BlogValuePropositionCard;
